import { QueryKeyParam, createQueryKey } from '../../query';

const locationsKeys = () =>
  createQueryKey({
    all: ['offers', 'locations'] as const,
    id: (locationId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'locations', locationId] as const,
        detail: ['offers', 'locations', locationId, 'detail'] as const,
      }),
  });

export { locationsKeys };
